import { useActions, useGLTFWithAppliedActions } from '@k3/core';
import { useK3ModelAndAction } from './useK3ModelAndAction';

export const useK3Model = (modelKey: string) => {
  const actions = useActions();
  const { model, modelAction, component } = useK3ModelAndAction(modelKey);

  if (!model) {
    return {};
  }

  const loadedModel = useGLTFWithAppliedActions({
    fileURL: model?.path || '',
    model: model!,
    materialActions: actions?.materials,
    colorActions: actions?.colors,
    printActions: actions?.prints,
    modelAction,
    meshProps: modelAction?.props,
  });

  return {
    model,
    loadedModel,
    modelAction,
    component,
  };
};
